export const IG_TAG = "@gioia.centroestetico";
const W = 1080, H = 1920;
const INK = "#14110F", BONE = "#F6F2EC", GOLD = "#C9A66B", MUTED = "#c9bfb2";

const loadImg = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

const wrap = (ctx, text, maxW) => {
  const lines = [];
  let cur = "";
  text.split(" ").forEach((w) => {
    const t = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(t).width <= maxW) cur = t;
    else { lines.push(cur); cur = w; }
  });
  return [...lines, cur];
};

const drawCover = (ctx, img, x, y, w, h, pos = "50% 50%") => {
  const [px, py] = pos.split(" ").map((p) => parseFloat(p) / 100);
  const r = Math.max(w / img.width, h / img.height);
  const sw = w / r, sh = h / r;
  ctx.drawImage(img, (img.width - sw) * px, (img.height - sh) * py, sw, sh, x, y, w, h);
};

const archPath = (ctx, x, y, w, h) => {
  const r = w / 2;
  ctx.beginPath();
  ctx.moveTo(x, y + h);
  ctx.lineTo(x, y + r);
  ctx.arc(x + r, y + r, r, Math.PI, 0);
  ctx.lineTo(x + w, y + h);
  ctx.closePath();
};

export const renderGlowCard = async ({ title, tip, img, pos, url }) => {
  await Promise.all([
    document.fonts.load('300 120px "Cormorant Garamond"'),
    document.fonts.load('italic 300 60px "Cormorant Garamond"'),
    document.fonts.load('500 30px "Manrope"'),
  ]).catch(() => {});
  const [logo, photo] = await Promise.all([loadImg("/images/logo-gioia-light.png"), loadImg(img)]);
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  ctx.fillStyle = INK;
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W * 0.85, 260, 0, W * 0.85, 260, 700);
  glow.addColorStop(0, "rgba(201,166,107,0.22)");
  glow.addColorStop(1, "rgba(201,166,107,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  const lh = 150, lw = (logo.width * lh) / logo.height;
  ctx.drawImage(logo, (W - lw) / 2, 120, lw, lh);

  const ax = 190, ay = 360, aw = 700, ah = 760;
  ctx.save();
  archPath(ctx, ax, ay, aw, ah);
  ctx.clip();
  drawCover(ctx, photo, ax, ay, aw, ah, pos);
  ctx.restore();
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 2;
  archPath(ctx, ax - 22, ay - 22, aw + 44, ah + 44);
  ctx.stroke();

  ctx.textAlign = "center";
  ctx.fillStyle = GOLD;
  ctx.font = '500 30px "Manrope", sans-serif';
  ctx.letterSpacing = "8px";
  ctx.fillText("IL MIO TRATTAMENTO IDEALE", W / 2, 1250);
  ctx.letterSpacing = "0px";

  ctx.fillStyle = BONE;
  ctx.font = '300 104px "Cormorant Garamond", serif';
  let y = 1370;
  wrap(ctx, title, 900).slice(0, 2).forEach((ln) => { ctx.fillText(ln, W / 2, y); y += 108; });

  ctx.fillStyle = "#e6d3ae";
  ctx.font = 'italic 300 46px "Cormorant Garamond", serif';
  y += 10;
  wrap(ctx, tip, 860).slice(0, 3).forEach((ln) => { ctx.fillText(ln, W / 2, y); y += 56; });

  ctx.fillStyle = GOLD;
  ctx.fillRect(W / 2 - 60, 1700, 120, 2);
  ctx.fillStyle = BONE;
  ctx.font = '500 40px "Manrope", sans-serif';
  ctx.fillText(IG_TAG, W / 2, 1772);
  ctx.fillStyle = MUTED;
  ctx.font = '400 28px "Manrope", sans-serif';
  ctx.fillText(`Scopri il tuo: ${url}`, W / 2, 1830);

  return new Promise((resolve) => c.toBlob(resolve, "image/png"));
};
